<div class="matrix_layoutMain container"  v-bind:class="getClassNameContainer">
    <div class="row">
        <div class="col-md-12" >     
            <!-- <appQuantitySelectionContainer></appQuantitySelectionContainer>             -->
            <appCostCenter></appCostCenter>
            <appQuantityTable v-if="!getCimpressNoQuantity">
                <appQuantityContainer></appQuantityContainer>
                <appInputQuantity></appInputQuantity>
            </appQuantityTable>
            <appOtherOptionsTable>
                <appOtherOptionsContainer></appOtherOptionsContainer>
            </appOtherOptionsTable>
            <appOptionsTable>
                <appOptionsContainer></appOptionsContainer>
                <appInputCustomFormatInsert></appInputCustomFormatInsert>
            </appOptionsTable>
            <appQuantityTable v-if="getCimpressNoQuantity">
                <appQuantityContainer></appQuantityContainer>
                <appInputQuantity></appInputQuantity>
            </appQuantityTable>
            <appAddToCartButton></appAddToCartButton>    
            <appQuotationButton></appQuotationButton>                         
        </div>
    </div>    
</div>